module.exports = __webpack_public_path__ + "static/img/bcg_unit2.a50279b6.png";